<template>

  <div>

  <b-modal
    v-show="!isLoading"
    :id="'add-devis-modal-' + this.operationConstruction.id"
    :cancel-title="$t(cancelTitle)"
    :cancel-variant="this.cancelVariant"
    :ok-title="$t(okTitle)"
    :title="$t(okTitle) + ' ' + $t('devis') + ' : ' + operationConstructionName"
    centered
    ok-variant="primary"
    @cancel="handleAddAndValidate"
    @hidden="resetModal"
    @ok="handleAdd">

    <!-- Custom Header -->
    <template #modal-header>
      <div class="d-flex align-items-center">
        <div class="header-button" @click="hideModal()">
          <chevron-left-icon size="18"/>
        </div>
        <div class="ml-3">
          <h5 class="mb-0">{{ $t(okTitle) + ' ' + $t('devis') }}</h5>
          <p class="mb-0 mt-1 page-subtitle" style="font-size: 16px">{{ operationConstructionName }}</p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div class="modal-footer d-flex align-items-center w-100 flex-wrap">
        <div v-if="hasInvoices" class="ml-auto">
          {{ $t('devis.facture.already.linked.edit') }}
        </div>
        <template v-else>
          <div class="d-flex ml-auto">
            <b-button
              :disabled="hasInvoices"
              :variant="cancelVariant"
              class="btn mr-2"
              @click="handleAddAndValidate">
              {{ $t(cancelTitle) }}
            </b-button>
            <b-button
              class="btn"
              variant="primary"
              @click="handleAdd">
              {{ $t(okTitle) }}
            </b-button>
          </div>
          <div v-if="cancelTitle==='devis.addAndValidate' || cancelTitle ==='devis.editAndValidate'"
               class="footer-override-prixTTC w-100">
            {{
              $t('devis.override.price.construction', {
                okTitle: okTitle === "Modify" ? $t('modify') : $t("add"),
                operationConstructionName: operationConstructionName
              })
            }}
          </div>
        </template>

      </div>
    </template>


    <div class="row">
      <div class="col-md-6">
        <AutoCompleteObjectField
          v-if="!isLoading"
          :input-class="'medium-label mb-4'"
          :input-id="'artisan-input'"
          :input-label="$t('devis.Artisan')"
          :items="contacts"
          :required=true
          :selectedElement="artisan"
          @elementValueChanged="getSelectedValue">
        </AutoCompleteObjectField>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('devis.Numero')"
          class="medium-label mb-4"
          label-for="numero-input">
          <b-form-input
            id="numero-input"
            v-model="numero"
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t(`devis.Prix${isHT ? 'HT':'TTC'}`)"
          class="medium-label mb-4"
          label-for="name-input">
          <b-form-input
            id="prixTTC-input"
            v-model="prixModel"
            v-disable-scroll
            :disabled="prixTTCDisabled"
            min="0"
            required
            step="any"
            type="number">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          :label="$t('devis.TauxTVA')"
          class="medium-label mb-4"
          label-for="uniteConstruction-input">
          <b-form-select
            id="uniteConstruction-input"
            v-model="tauxTVA">
            <option v-for="option in tauxTVAList" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-md-12">
        <multi-file-field
          v-if="!isLoading"
          :label="$t('Documents').toString()"
          :new-files-list="newDocumentsList"
          :old-files-list="oldDocumentsList"
          @addFiles="addDocuments"
          @removeNewFile="removeNewDocument"
          @removeOldFile="removeOldDocument"/>
      </div>
    </div>

  </b-modal>

  <!-- Modale de confirmation d'invalidation de l'ancien devis validé -->
  <b-modal
    :id="'confirm-invalidate-old-devis-' + this.operationConstruction.id"
    title="Confirmation"
    centered
    ok-variant="danger"
    ok-title="Confirmer"
    cancel-title="Annuler"
    cancel-variant="primary"
    @ok="confirmInvalidateOldDevisOk"
    @cancel="confirmInvalidateOldDevisCancel">
    <div>
      <p>
        {{$t('add.devis.validated.confirmation.text')}}
      </p>
    </div>
  </b-modal>

  </div>

</template>

<script>

import api from "../../../services/api";
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField.vue";
import MultiFileField from "../../../components/b122/editFields/MultiFileField.vue";
import AutoCompleteObjectField from "../../../components/b122/editFields/AutoCompleteObjectField.vue";

export default {

  name: "AddDevisModal",

  components: {
    AutoCompleteObjectField,
    MultiFileField,
    AutocompleteField
  },

  props: {
    selectedDevisIndexProp: null,
    operationConstructionName: "",
    operationConstruction: {
      type: Object,
      default: null
    },
    tauxTVAList: {
      type: Array,
      default() {
        return []
      }
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },


  data() {
    let cancelVariant = 'success'
    let cancelTitle = 'devis.addAndValidate'
    let okTitle = 'Add'
    let prixTTCDisabled = false
    let devis = this.operationConstruction.devis[this.selectedDevisIndexProp]
    if (devis) {
      okTitle = 'Modify'
      if (devis.validated) {
        cancelTitle = 'devis.Unvalidate'
        cancelVariant = 'danger'
        prixTTCDisabled = true
      } else {
        cancelTitle = 'devis.editAndValidate'
      }
    }
    return {
      devis: devis,
      selectedDevisIndex: this.selectedDevisIndexProp,
      cancelVariant: cancelVariant,
      cancelTitle: cancelTitle,
      okTitle: okTitle,
      numero: "",
      artisan: null,
      prixTTC: null,
      prixHT: null,
      prixTTCDisabled: prixTTCDisabled,
      tauxTVA: "20%",
      documents: null,
      contacts: [],
      newDocumentsList: [],
      oldDocumentsList: [],
      documentsToRemove: [],
      isLoading: true,
      pendingValidationForNewDevis: false,
    }
  },

  emits: ['didAddDevis'],

  async mounted() {
    await this.fetchData()
  },

  computed: {
    hasInvoices() {
      if (this.devis && this.devis.schedule && this.devis.schedule.paiements) {
        return this.devis.schedule.paiements.some(payment => payment.facture);
      }
      return false;
    },
    prixModel: {
      get() {
        return this.isHT ? this.prixHT : this.prixTTC
      },
      set(val) {
        if (this.isHT) {
          this.prixHT = val
        } else {
          this.prixTTC = val
        }
      }
    }
  },

  watch: {
    selectedDevisIndexProp: {
      handler(newVal) {
        if (newVal) {
          let cancelVariant = 'success'
          let cancelTitle = 'devis.addAndValidate'
          let okTitle = 'Add'
          let prixTTCDisabled = false
          let devis = this.operationConstruction.devis[this.selectedDevisIndexProp]
          if (devis) {
            okTitle = 'Modify'
            if (devis.validated) {
              cancelTitle = 'devis.Unvalidate'
              cancelVariant = 'danger'
              prixTTCDisabled = true
            } else {
              cancelTitle = 'devis.editAndValidate'
            }
          }
          this.devis = devis
          this.selectedDevisIndex = this.selectedDevisIndexProp
          this.cancelVariant = cancelVariant
          this.cancelTitle = cancelTitle
          this.okTitle = okTitle
          this.numero = ""
          this.prixTTCDisabled = prixTTCDisabled
        } else {
          this.resetModal()
        }
      },
      deep: true
    },
    operationConstruction: {
      immediate: true,
      handler(newVal) {
        this.initializeValues()
      },
      deep: true
    },
  },

  methods: {

    getSelectedValue(data) {
      this.artisan = data
    },

    async fetchData() {
      await this.getContacts()
      this.initializeValues()
    },

    initializeValues() {
      if (this.devis) {
        this.numero = this.devis.numero
        this.artisan = this.devis.artisan
        this.prixTTC = this.devis.prixTTC
        this.prixHT = this.devis.prixHT
        this.tauxTVA = this.devis.tauxTVA
        this.documents = this.devis.documents
        this.oldDocumentsList = this.devis.documents
      } else {
        this.resetModal()
        this.hideModal()
      }
      this.isLoading = false
    },

    async getContacts() {
      await api
        .get(`/contact/getContacts`)
        .then(response => {
          this.contacts = response.data
        })
    },

    handleAddAndValidate(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.devis && this.devis.validated) {
        this.devis.validated = false
        this.devis.status = "WAITING"
        this.handleSubmit(false)
      } else if (this.devis && this.devis.status === "REFUSED") {
        this.devis.status = "WAITING"
        this.handleSubmit(false)
      } else {
        if (this.devis) {
          this.devis.validated = true
          this.devis.status = "VALIDATED"
          this.handleSubmit(true)
        } else {

          const alreadyValidated = (this.operationConstruction.devis || []).some(d => d && d.validated)
          if (alreadyValidated) {
            this.pendingValidationForNewDevis = true
            this.$bvModal.show('confirm-invalidate-old-devis-' + this.operationConstruction.id)
          } else {
            this.handleSubmit(true)
          }
        }
      }
    },

        handleAdd(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.devis) {
        this.handleSubmit(this.devis.validated)
      } else {
        this.handleSubmit(false)
      }
    },

    async confirmInvalidateOldDevisOk() {
      try {
        const validatedDevis = (this.operationConstruction.devis || []).find(d => d && d.validated)
        if (validatedDevis && validatedDevis.schedule && Array.isArray(validatedDevis.schedule.paiements)) {
          for (const p of validatedDevis.schedule.paiements) {
            if (p && p.facture && p.facture.id) {
              await api.delete(`/facturePayment/${p.facture.id}`)
            }
          }
        }
        (this.operationConstruction.devis || []).forEach(d => {
          if (d) {
            d.validated = false
            d.status = 'WAITING'
          }
        })
      } catch (e) {
        console.error('Erreur lors de l\'invalidation du devis existant:', e)
      }

      this.pendingValidationForNewDevis = false
      this.handleSubmit(true)
    },

    confirmInvalidateOldDevisCancel() {
      this.pendingValidationForNewDevis = false
    },

    handleSubmit(validated) {
      if (this.prixTTC && this.artisan) {
        let prixTTCToSave
        if (this.isHT) {
          const taux = parseFloat(this.tauxTVA.replace('%', '')) / 100
          prixTTCToSave = this.prixHT * (1 + taux)
        } else {
          prixTTCToSave = this.prixTTC
        }
        if (this.devis) {
          this.devis.numero = this.numero
          this.devis.artisan = this.artisan
          this.devis.prixTTC = prixTTCToSave
          this.devis.tauxTVA = this.tauxTVA
          this.devis.documents = this.newDocumentsList.concat(this.oldDocumentsList)
          this.devis.validated = validated
        } else {
          this.devis = {
            numero: this.numero,
            artisan: this.artisan,
            prixTTC: prixTTCToSave,
            tauxTVA: this.tauxTVA,
            prixHT: this.isHT ? this.prixHT : null,
            documents: this.newDocumentsList,
            validated: !!validated,
            status: validated ? "VALIDATED" : "WAITING"
          }
          this.operationConstruction.devis.push(this.devis)
        }

        // NE PAS invalider les autres devis pour préserver les factures associées
        // if (validated) {
        //   this.operationConstruction.devis.forEach((item) => {
        //     if (item !== this.devis) {
        //       item.validated = false
        //       item.status.value = "WAITING"
        //     }
        //   })
        // }

        this.operationConstruction.lastModifDate = Date.now()
        this.$emit('didAddDevis', this.operationConstruction)
        this.resetModal()
        this.hideModal()
      } else {
        this.errorToast()
      }
    },

    resetModal() {
      this.numero = ""
      this.artisan = null
      let prixBase = this.operationConstruction.surface ?
        (this.operationConstruction.surface * (this.isHT ? this.operationConstruction.prixParM2HT : this.operationConstruction.prixParM2)) :
        (this.isHT ? this.operationConstruction.prixParM2HT : this.operationConstruction.prixParM2)

      if (this.isHT) {
        this.prixHT = prixBase && !isNaN(prixBase) ? Number(prixBase).toFixed(2) : 0
      } else {
        this.prixTTC = prixBase && !isNaN(prixBase) ? Number(prixBase).toFixed(2) : 0
      }

      this.prixTTC = prixBase && !isNaN(prixBase) ? Number(prixBase).toFixed(2) : 0
      this.tauxTVA = "20%"
      this.newDocumentsList = []
      this.selectedDevisIndex = null
      this.tauxTVA = "20%"
      this.documents = null
      this.newDocumentsList = []
      this.oldDocumentsList = []
      this.documentsToRemove = []
      this.isLoading = false
      this.cancelVariant = 'success'
      this.cancelTitle = 'devis.addAndValidate'
      this.okTitle = 'Add'
      this.prixTTCDisabled = false
      this.devis = this.operationConstruction.devis[this.selectedDevisIndexProp]
      this.$emit('resetSelectedDevisIndex')

      if (!this.devis && this.operationConstruction && this.operationConstruction.pourcentage && this.operationConstruction.pourcentage > 0) {
        this.prefillPrixTTCFromPourcentage()
      }
    },

    getOperationId() {
      if (this.operationConstruction && this.operationConstruction.operation && this.operationConstruction.operation.hasOwnProperty('id') && this.operationConstruction.operation.id) {
        return this.operationConstruction.operation.id
      } else if (this.operationConstruction && this.operationConstruction.operationLot && this.operationConstruction.operationLot.operation && this.operationConstruction.operationLot.operation.id) {
        return this.operationConstruction.operationLot.operation.id
      }
      return null
    },

    async prefillPrixTTCFromPourcentage() {
      try {
        const operationId = this.getOperationId()
        if (!operationId) {
          return
        }

        let baseValue = 0
        const pourcentage = this.operationConstruction.pourcentage / 100

        if (this.operationConstruction.uniteConstruction && this.operationConstruction.uniteConstruction.value === 'POURCENTAGE_CA_TTC') {
          const response = await api.get(`/operationConstruction/getCATTC?operationId=${operationId}`)
          baseValue = response.data.caTTC || 0
        } else if (this.operationConstruction.uniteConstruction && this.operationConstruction.uniteConstruction.value === 'POURCENTAGE_COUT_TRAVAUX') {
          const response = await api.get(`/operationConstruction/getCoutTravaux?operationId=${operationId}`)
          baseValue = response.data.coutTravaux || 0
        } else {
          const response = await api.get(`/operationConstruction/getPrixRevient?operationId=${operationId}`)
          baseValue = response.data.prixRevient || 0
        }

        const prixCalcule = (baseValue * pourcentage) / 100
        this.prixTTC = Number(prixCalcule).toFixed(2)
      } catch (error) {
        console.error('Erreur lors du calcul du pourcentage dans AddDevisModal:', error)
      }
    },

    hideModal() {
      this.resetModal()
      this.$bvModal.hide('add-devis-modal-' + this.operationConstruction.id)
    },

    addDocuments(files) {
      files.forEach(file => {
        if (file) {
          this.newDocumentsList.push(file)
        }
      })
    },

    removeNewDocument(file) {
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
    },

    removeOldDocument(fileToRemove) {
      this.newDocumentsList = this.newDocumentsList.filter(file => file.id !== fileToRemove.id);

      this.oldDocumentsList = this.oldDocumentsList.filter(file => file.id !== fileToRemove.id);

      this.documents = this.documents.filter(file => file.id !== fileToRemove.id);

      if (fileToRemove.id) {
        api.delete(`/operationDevis/deleteFileDevis/${fileToRemove.id}`);
      }
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }

  }

}

</script>

<style scoped>

.header-button {
  display: inline-block;
  background-color: var(--main-color);
  border-radius: var(--main-border-radius);
  height: 24px;
  width: 24px;
  margin-right: 0.5em;
  color: white;
}

.header-button svg {
  height: 24px;
  width: 24px;
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-color-hover);
  color: var(--main-white);
}

.footer-override-prixTTC {
  font-size: 12px;
  display: flex;
  justify-content: end;
  text-align: end;
  color: var(--tertiary-text-color);
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/AddDevisModal.vue